export default __webpack_public_path__ + "static/media/algo2.fda5e727.png";